import React from 'react'
import colors from '../../constants/colors'
import Flex from '../Flex'
import { placementVariant, whitespace } from './variant'
import { TooltipProps } from './Tooltip.types'
import styled from 'styled-components'
import Box from '../Box'
import Text from '../Text'
import useDisclosure from '../../hooks/useDisclosure'

const StyledFlex = styled(Flex)<TooltipProps>`
  ${placementVariant}
  ${whitespace}
`
const index: React.FC<TooltipProps> = ({
  label,
  icon,
  children,
  backgroundColor = 'white',
  color = 'black75',
  placement = 'bottom',
  width = 'fit-content',
  height = 'fit-content',
  containerWidth = 'fit-content',
  ...restProps
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure({ open: false })

  return (
    <Box position='relative' width={containerWidth} onMouseEnter={onOpen} onMouseLeave={onClose}>
      {icon || children}
      {isOpen && (
        <StyledFlex
          whitespace={icon ? 'normal' : 'nowrap'}
          borderRadius='8px'
          padding='8px'
          backgroundColor={backgroundColor}
          border={`1px solid ${colors['black10']}`}
          justifyContent='center'
          alignItems='center'
          placement={placement}
          width={icon ? '126px' : width}
          height={height}
          color={color}
          boxShadow='0px 4px 10px 0px #0000000D'
          position='absolute'
          cursor='pointer'
          zIndex='1'
          marginTop='4px'
          {...restProps}
        >
          <Text variant='small' color='black75'>
            {label}
          </Text>
        </StyledFlex>
      )}
    </Box>
  )
}

export default index
